<template>
    <div>
        <el-form label-position="right" :model="form" label-width="100px">
            <el-form-item label="真实姓名:" prop="realName" :rules="[{
                required: true,
                message: '请输入真实姓名',
                trigger: 'blur'
            }]">
                <el-input v-model="form.realName" style="width: 350px;" ref="refRealName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号:" class="itemForm" prop="idCard" :rules="[{
                required: true,
                message: '请输入身份证号',
                trigger: 'blur'
            }]">
                <el-input v-model="form.idCard" style="width: 350px;"></el-input>
            </el-form-item>
            <el-form-item label="证件上传:" class="itemForm" style="margin-top: 5px;" :required="true">
                <span style="font-size: 12px;color: #CCCCCC;">（单张图片上传请控制在2-3M以内，点击下方区域或将文件拖动至区域内，图片支持格式：jpg、png）</span>
            </el-form-item>
            <el-form-item>
                <div style="display: flex;">
                    <div style="flex:0 0 200px">
                        <el-upload :action="uploadUrl" :show-file-list="false" :on-success="uploadSuccessOne"
                                   :before-upload="beforeUpload">
                            <img class="imgId" :src="imgFront" alt="">
                        </el-upload>
                    </div>
                    <div style="margin-left: 1em;">
                        <el-upload :action="uploadUrl" :show-file-list="false" :on-success="uploadSuccessTwo"
                                   :before-upload="beforeUpload">
                            <img class="imgId" :src="imgBack" alt="">
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width: 180px;" v-if="confirmUrl.length > 0"
                           @click="doCommit(confirmUrl)">确认
                </el-button>
                <el-button type="primary" style="width: 180px;" v-if="preUrl.length > 0" @click="goPre"
                           plain="plain">
                    上一步
                </el-button>
                <el-button type="primary" style="width: 180px;" v-if="nextUrl.length > 0" @click="doCommit(nextUrl)">
                    完成进入下一步
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Login from '../../login/Login'

export default {
    name: 'SubRealnameContent',
    props: ['url', 'pre', 'next'],
    data: function () {
        return {
            id: 0,
            form: {
                idCard: '',
                realName: '',
            },
            uploadUrl: '',
            imgFront: require('@/assets/images/id/id_front.png'),
            imgFrontUploaded: false,
            imgBack: require('@/assets/images/id/id_back.png'),
            imgBackUploaded: false,
            confirmUrl: '',
            preUrl: '',
            nextUrl: ''
        }
    },
    created () {
        this.uploadUrl = localStorage.getItem('ServerUrl') + '/api/file/uploadfile'
        if (!this.isEmpty(this.url)) {
            this.confirmUrl = this.url
        }
        if (!this.isEmpty(this.pre)) {
            this.preUrl = this.pre
        }
        if (!this.isEmpty(this.next)) {
            this.nextUrl = this.next
        }
        this.getDefaultValue()
    },
    mounted () {
        this.$refs.refRealName.focus()
    },
    methods: {
        getDefaultValue () {
            let that = this
            this.$ajax.get('/api/userauth/getbyuserid').then(function (res) {
                if (that.isEmpty(res.data)) {
                    return
                }
                //赋值
                that.id = res.data.id
                that.form.realName = res.data.real_name
                that.form.idCard = res.data.id_number
                that.imgFront = res.data.id_front
                if (that.imgFront.length > 0) {
                    that.imgFrontUploaded = true
                }
                that.imgBack = res.data.id_back
                if (that.imgBack.length > 0) {
                    that.imgBackUploaded = true
                }
            })
        },
        doCommit: function (url) {
            if (this.isEmpty(this.form.realName)) {
                this.showError('请输入真实姓名')
                return
            }
            if (this.isEmpty(this.form.idCard)) {
                this.showError('请输入身份证号')
                return
            }
            // let idCheckResult = this.isIdCard(this.form.idCard)
            // console.log('idCheck:', this.idCheck(this.form.idCard))
            // if (!idCheckResult.result) {
            //     this.showError(idCheckResult.msg)
            //     return
            // }
            if (!this.imgFrontUploaded) {
                this.showError('请上传身份证正面')
                return
            }
            if (!this.imgBackUploaded) {
                this.showError('请上传身份证反面')
                return
            }
            //提交数据
            let params = {
                real_name: this.form.realName,
                id_number: this.form.idCard,
                id_front: this.imgFront.replace(this.getServerUrl(), ''),
                id_back: this.imgBack.replace(this.getServerUrl(), '')
            }
            let apiUrl = '/api/userauth/create'
            if (!this.isEmpty(this.id)) {
                params.id = this.id
                //设置状态
                params.status = 0
                apiUrl = '/api/userauth/update'
            }
            let that = this
            this.$ajax.post(apiUrl, params).then(function (res) {
                //设置当前页面的id
                that.id = res.data.id
                that.goNext(url)
            })
        },
        beforeUpload (file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                this.showError('只能是jpg或png格式')
                return false
            }
            if (file.size > 2 * 1024 * 1024) {
                this.showError('图片大小不能超过2MB')
                return false
            }
            return true
        },
        uploadSuccessOne (res, file) {
            this.imgFront = localStorage.getItem('ServerUrl') + res.data.file
            this.imgFrontUploaded = true
        },
        uploadSuccessTwo (res, file) {
            this.imgBack = localStorage.getItem('ServerUrl') + res.data.file
            this.imgBackUploaded = true
        },
        goNext (url) {
            if (this.isEmpty(url)) {
                this.$message.success('数据提交成功')
            } else {
                this.$router.push({
                    path: url
                })
            }
        },
        goPre () {
            this.$router.push({
                path: this.preUrl
            })
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.div-notice {
    background-color: #f5f6fa;
    border-radius: 5px;
    padding: 20px;
}

.div-notice p {
    padding: 0;
    margin: 0;
    line-height: 25px;
    color: #999999;
}

.imgId {
    width: 250px;
    height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/sub/SubRealNameContent.vue